import { useEffect } from 'react'

import { shallowEqual } from 'react-redux'

import { Area, AreaSource } from 'store/area/types'
import { getStatus as getAuditStatus } from 'store/audit/auditSlice'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { State } from 'store/state'

import { getAssessmentProgress } from '../utils/getAssessmentProgress'

export const useAreaProgress = ({
  area,
  group,
}: {
  group?: AreaSource
  area?: Partial<Area>
}): Record<string, any> => {
  const dispatch = useAppDispatch()
  const { status } = useAppSelector(
    (state: State) => ({
      status: state.auditReducer.areas?.[area?.code ?? ''],
    }),
    shallowEqual
  )

  useEffect(() => {
    if (
      area?.code &&
      (group === AreaSource.COMPANY || !group) &&
      !status?.loading &&
      status?.questions === undefined
    ) {
      dispatch(getAuditStatus(area.code))
    }
  }, [area, dispatch, group, status])

  if (group === 'company' && area) {
    return getAssessmentProgress({ status })
  }

  if (!group && area) {
    const assessment = getAssessmentProgress({ status })
    const completed = assessment?.completed ?? 0
    const total = assessment?.total ?? 0

    return { completed, total }
  }
  return {
    disabled: false,
    total: 0,
    skipped: 0,
    completed: 0,
    reviewed: 0,
    rejected: 0,
    submitted: 0,
  }
}
